import { ethers } from "ethers";
import nacl from "tweetnacl";
import {
  signSolanaMessage,
  type ConnectedSolanaWallet,
} from "../joinsplit-v2/solana/walletStandard";
import {
  HANDLE_REGISTRY_CHAIN_ID,
  handleRegistryAddress,
} from "./handle-networks";
import type { HandleWalletSigner } from "./handle-ownership";

/** A distinct, stable message for handle sharing. It never authorizes a
 * transaction and its verified signature never leaves the browser. */
export function solanaHandleOwnershipMessage(address: string): string {
  return [
    "StealthOS handle ownership",
    "Use your .stealth handle on another network.",
    "This signature unlocks your encrypted handle backup. It is not a transaction.",
    `Wallet: ${address}`,
    `Registry chain: ${HANDLE_REGISTRY_CHAIN_ID}`,
    `Registry: ${handleRegistryAddress()}`,
    "Version: 1",
  ].join("\n");
}

export function solanaHandleSigner(
  connection: ConnectedSolanaWallet,
): HandleWalletSigner {
  return {
    getAddress: async () => connection.address,
    requestHandleOwnershipRoot: async () => {
      const message = new TextEncoder().encode(
        solanaHandleOwnershipMessage(connection.address),
      );
      const signature = await signSolanaMessage(connection, message);
      if (!nacl.sign.detached.verify(message, signature, connection.publicKey))
        throw new Error("The wallet's handle signature did not verify");
      return ethers.keccak256(signature);
    },
  };
}
